"use client";

import React from "react";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DjTaurxOfficial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const socialLinks = [{
    icon: Instagram,
    href: "https://instagram.com/djtaurx",
    label: "Instagram"
  }, {
    icon: MessageCircle,
    href: "https://wa.me/9820970096",
    label: "WhatsApp"
  }, {
    icon: Mail,
    href: "mailto:info@djtaurx.com",
    label: "Email"
  }];
  return <section id="dj-taurx-official" ref={ref} className="dark bg-background py-16 w-full flex flex-col items-center justify-center transition-opacity duration-1000 opacity-100 !text-[hsl(50,98%,64%)]">
      {}
      <div className="mb-8 text-center">
        <h2 className="font-serif text-5xl tracking-wide font-bold uppercase !text-[hsl(50,98%,64%)] md:text-[48px]">
          DJ Taurx
        </h2>
      </div>

      {}
      <Separator className="w-[80%] bg-foreground/30 h-px mb-8" />

      {}
      <div className="w-[80%] flex flex-col md:flex-row items-center justify-between gap-6 md:gap-0">
        {}
        <div className="order-3 md:order-1 w-full md:w-auto flex justify-center md:justify-start">
          <p className="font-sans text-xs text-muted-foreground tracking-wide">
            © 2024 DJ TAURX
          </p>
        </div>

        {}
        <div className="order-2 w-full md:w-auto flex justify-center">
          <p className="font-serif text-[10px] uppercase tracking-[0.2em] italic !text-[hsl(0,0%,100%)]">
            Born to dominate
          </p>
        </div>

        {}
        <div className="order-1 md:order-3 w-full md:w-auto flex justify-center md:justify-end gap-6">
          {socialLinks.map((social, i) => <Link key={i} to={social.href} newTab className="text-foreground hover:text-primary transition-colors duration-300" aria-label={social.label} data-index={i}>
              <social.icon className="w-5 h-5" strokeWidth={1.5} />
            </Link>)}
        </div>
      </div>
    </section>;
}